export function localeParseFloat(s, locale) {
  const separators = Array.from(s).reduce(
    (previousValue, currentValue) =>
      '.,'.includes(currentValue)
        ? previousValue.concat(currentValue)
        : previousValue,
    [],
  );
  const decimalSeparator = separators.slice(-1);
  if (decimalSeparator[0] === ',') {
    return parseFloat(s.replace(/[^0-9,]/i, '').replace(/,/i, '.'));
  }
  return parseFloat(s);
}
